export const translationTypes = ['vidio', 'postQuestions'];
